<!--
 * @Author: ljc_625738144@qq.com
 * @Date: 2023-09-27 15:43:16
 * @LastEditors: ljc_625738144@qq.com
 * @LastEditTime: 2024-10-11 18:01:00
 * @Description:
 * @FilePath: \haozhang_pro\src\components\publicTable\column\TableColumn.vue
-->
<template>
  <el-table-column
    v-if="columnData.show !== false && columnData.show === 'template'"
    :key="columnData.value"
    :prop="columnData.value"
    :label="columnData.label"
    :min-width="columnData.width"
    :class-name="columnData.value"
    :fixed="columnData.fixed"
    :render-header="renderHeader"

    :sortable="columnData.order"
    :show-overflow-tooltip="showOverflowTooltip"
  >
    <template slot-scope="scope">
      <slot :name="columnData.value" :obj="scope"></slot>
    </template>
  </el-table-column>
  <el-table-column
    v-else-if="columnData.show !== false && columnData.show === 'normal'"
    :sortable="columnData.order"
    :prop="columnData.value"
    :render-header="renderHeader"
    :key="columnData.value"
    :label="columnData.label"
    :min-width="columnData.width"
    :class-name="columnData.value"
    :formatter="columnData.formatter"
    :fixed="columnData.fixed"
    :show-overflow-tooltip="showOverflowTooltip"
  >
  </el-table-column>
</template>

<script>
export default {
  name: "TableColumn",
  props: {
    showOverflowTooltip: {
      type: Boolean,
      default: true,
    },
    columnData: {
      type: Object,
      default: () => {},
    },
    renderHeader: Function,
  },
  data() {
    return {
    };
  },
  mounted() {},
  methods: {
  },
};
</script>



// WEBPACK FOOTER //
// src/components/publicTable/column/TableColumn.vue